import * as React from "react";
import { useContext } from "react";
import { DropDownList, DropDownListChangeEvent } from "@progress/kendo-react-dropdowns";
import { FtlRouteViewModel } from "../../../../ViewModel/FtlRouteViewModel";
import { EditProjectContext } from "../../../EditProjectContext";
import { RouteType } from "../../../../ViewModel/RouteType";

type Props = {
  route: FtlRouteViewModel;
  isReadonly: boolean;
};

function RouteTypeField({ route, isReadonly }: Props) {
  const { project, setProject, setStopDataOfSpdrsOrPdsrs } = useContext(EditProjectContext);

  const types = [
    { text: RouteType.FTL, value: RouteType.FTL },
    { text: RouteType.FTL2, value: RouteType.FTL2 },
    { text: RouteType.Trunk, value: RouteType.Trunk },
    { text: RouteType["Top-Up"], value: RouteType["Top-Up"] },
    { text: RouteType["ST-Return"], value: ["ST-Return"] },
  ];

  const [state, setState] = React.useState({
    value: { text: route.RouteType, value: route.RouteType },
  });

  const handleChange = (event: DropDownListChangeEvent) => {
    const valuePair = event.target.value;
    const { value } = valuePair;

    setState({
      value: valuePair,
    });

    setRouteType(route.RouteId, value ?? "undefined");
  };

  const setRouteType = (routeId: number, routeType: string) => {
    setStopDataOfSpdrsOrPdsrs([]);
    const updateFtlRoutes = (ftlRoute: FtlRouteViewModel) => {
      return ftlRoute.RouteId === routeId
        ? {
            ...ftlRoute,
            RouteType: routeType,
            OriginRegion: {},
            CrossingCountries: [],
            SpdrsOnThisRoute: [],
            RoutingTable: [],
            DragableElements: [],
            PdsrsOnThisRoute: [],
          }
        : ftlRoute;
    };

    setProject({
      ...project,
      FTLRoutes: project?.FTLRoutes?.map(updateFtlRoutes),
    });
  };

  return (
    <>
      <span style={{ paddingRight: "1rem" }}>Type</span>

      <DropDownList
        data={types}
        textField="text"
        dataItemKey="value"
        value={state.value}
        onChange={handleChange}
        disabled={isReadonly}
      />
    </>
  );
}

export default RouteTypeField;
